import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["margin", "children", "color", "as", "elementRef", "styles", "makeStyles", "statusLabel", "renderIcon"];
var _dec, _dec2, _class, _Pill;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { View } from '@instructure/ui-view';
import { passthroughProps } from '@instructure/ui-react-utils';
import { testable } from '@instructure/ui-testable';
import { Tooltip } from '@instructure/ui-tooltip';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { allowedProps, propTypes } from './props';

/**
---
category: components
---
**/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let Pill = (_dec = withStyle(generateStyle, generateComponentTheme), _dec2 = testable(), _dec(_class = _dec2(_class = (_Pill = class Pill extends Component {
  constructor(props) {
    super(props);
    this.ref = null;
    this.ellipsisRef = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
    this.state = {
      truncated: false
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    this.setTruncation();
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  setTruncation() {
    if (this.ellipsisRef) {
      this.setState({
        truncated: this.ellipsisRef.offsetWidth < this.ellipsisRef.scrollWidth
      });
    }
  }
  renderPill(focused, getTriggerProps) {
    const _this$props3 = this.props,
      margin = _this$props3.margin,
      children = _this$props3.children,
      color = _this$props3.color,
      as = _this$props3.as,
      elementRef = _this$props3.elementRef,
      styles = _this$props3.styles,
      makeStyles = _this$props3.makeStyles,
      statusLabel = _this$props3.statusLabel,
      renderIcon = _this$props3.renderIcon,
      props = _objectWithoutProperties(_this$props3, _excluded);
    const filteredProps = passthroughProps(props);
    const containerProps = typeof getTriggerProps === 'function' ? getTriggerProps(filteredProps) : filteredProps;
    const refProp = this.state.truncated ? {} : {
      elementRef: this.handleRef
    };
    return _jsx(View, {
      ...containerProps,
      as: as,
      ...refProp,
      margin: margin,
      padding: "0",
      maxWidth: styles === null || styles === void 0 ? void 0 : styles.maxWidth,
      background: "transparent",
      borderRadius: "pill",
      borderWidth: "0",
      display: "inline-block",
      position: "relative",
      withFocusOutline: focused,
      focusColor: "info",
      children: _jsxs("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.pill,
        children: [renderIcon && _jsx("div", {
          css: styles === null || styles === void 0 ? void 0 : styles.icon,
          children: renderIcon
        }), _jsxs("div", {
          css: styles === null || styles === void 0 ? void 0 : styles.text,
          ref: el => {
            this.ellipsisRef = el;
          },
          children: [statusLabel && _jsx("span", {
            css: styles === null || styles === void 0 ? void 0 : styles.status,
            children: statusLabel && statusLabel.concat(':')
          }), children]
        })]
      })
    });
  }
  render() {
    if (this.state.truncated) {
      return _jsx(Tooltip, {
        renderTip: this.props.statusLabel ? this.props.statusLabel.concat(': ', this.props.children) : this.props.children,
        elementRef: this.handleRef,
        children: ({
          focused,
          getTriggerProps
        }) => {
          return this.renderPill(focused, getTriggerProps);
        }
      });
    } else {
      return this.renderPill();
    }
  }
}, _Pill.displayName = "Pill", _Pill.componentId = 'Pill', _Pill.allowedProps = allowedProps, _Pill.propTypes = propTypes, _Pill.defaultProps = {
  color: 'primary'
}, _Pill)) || _class) || _class);
export default Pill;
export { Pill };